// src/views/dashboard/money-flow/ClientDashboard.jsx
import React, { Component } from 'react';
import '../../../../styles/components/client-dashboard.scss';
import HeaderBanner from '../../../common/HeaderBanner';
import { SideBar } from '../../sidebar';
import i18n from '../../../../i18n';
import FilterSection from '../../../common/Filter';
import { selectStyles } from '../../../../styles/components/js/selectStyle';
import Select from 'react-select';
import DateRangeTags from '../../../common/DateRangeTags';
import { NavLink } from 'react-router-dom';
import { ArrowBigDown, ArrowLeft, Download, FileSpreadsheet, Gavel, Wallet } from 'lucide-react';
import {
  getCashflowTransactions,
  getCashflowWithdrawal,
  getWinners,
} from './services/cashFlowService';
import NewDropdown from '../../../common/NewDropDown';
import CashFlowStatCard from './components/CashFlowStatCard';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import DataTable from 'react-data-table-component';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import NoData from '../../../common/NoData';
import ClientPaymentSkeleton from './components/ClientPaymentSkeleton';
import { formatDate } from '../../../../utils/common';
import { TRANSACTION_STATUS } from '../../../../constants/status';

function detectTag(startDate, endDate) {
  if (!startDate || !endDate) return 'custom';
  const presets = ['7', '30', '90', '365'];
  for (const tag of presets) {
    const range = DateRangeTags.resolveRange(tag);
    if (range.startDate === startDate && range.endDate === endDate) return tag;
  }
  return 'custom';
}

// ── MAIN ──────────────────────────────────────────────────────────────────────
class WalletWithdrawalCashFlow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: null,
      isLoading: false,
      hideSidebar: false,
      search: { startDate: '', endDate: '', bidder: null },
      clients: [],
      groups: [],
      bidders: [],
      clientLoading: false,
      groupLoading: false,
      bidderLoading: false,
      page: 1,
      limit: 15,
      dateTag: 'custom',
      type: 'withdrawal',
      withdawalData: [],
      withdawalMeta: null,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const params = new URLSearchParams(window.location.search);
    const urlStart = params.get('startDate');
    const urlEnd = params.get('endDate');

    let startDate, endDate, dateTag;

    if (urlStart && urlEnd) {
      // URL has explicit dates — restore them and detect which tag they match
      startDate = urlStart;
      endDate = urlEnd;
      dateTag = detectTag(urlStart, urlEnd);
    } else {
      // No URL dates — default to last 7 days
      dateTag = 'custom';
      // const range = DateRangeTags.resolveRange('7');
      // startDate = range.startDate;
      // endDate = range.endDate;
    }

    this.setState(
      {
        dateTag,
        search: {
          startDate,
          endDate,
          bidder: params.get('bidder') ? parseInt(params.get('bidder')) : null,
        },
        page: parseInt(params.get('page')) || 1,
        limit: parseInt(params.get('limit')) || 15,
      },
      () => {
        this.fetchBidderList();
        this.fetchWithdrawal();
        this.fetchWithdrawalSymmary();
      }
    );
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async fetchWithdrawal() {
    this.setState({ isLoading: true });
    try {
      let { limit, page, type } = this.state;
      const { startDate, endDate, bidder } = this.state.search;
      const q = {
        page: page,
        limit: limit,
      };
      if (startDate) q.startDate = startDate;
      if (endDate) q.endDate = endDate;
      if (bidder) q.bidder = bidder;
      if (type) q.type = type;

      this.updateUrlQuery(q);

      const response = await getCashflowTransactions(q); // your API model fn

      if (response.success) {
        this.setState({
          withdawalData: response.data,
          total: response.meta.total,
          isLoading: false,
        });
      } else {
        this.setState({ isLoading: false });
      }
    } catch {
      this.setState({ isLoading: false });
    }
  }

  async fetchWithdrawalSymmary() {
    this.setState({ isLoading: true });
    try {
      const { startDate, endDate, bidder } = this.state.search;
      const q = {};
      if (startDate) q.startDate = startDate;
      if (endDate) q.endDate = endDate;
      if (bidder) q.bidder = bidder;

      this.updateUrlQuery(q);

      const response = await getCashflowWithdrawal(q); // your API model fn

      if (response.success) {
        this.setState({
          withdawalMeta: response.data,
          isLoading: false,
        });
      } else {
        this.setState({ isLoading: false });
      }
    } catch {
      this.setState({ isLoading: false });
    }
  }
  async fetchBidderList() {
    this.setState({ bidderLoading: true });
    const { client, group } = this.state.search;

    const q = {};
    if (client) q.client = client;
    if (group) q.group = group;

    const response = await getWinners(q);
    if (response.success) {
      const bidders = [
        {
          value: null,
          label: i18n.t('all') || 'All',
        },
        ...response.data.map((item) => ({
          value: item.id,
          label: `${item.name} (${item.id})`,
        })),
      ];

      this.setState({
        bidders,
        bidderLoading: false,
      });
    } else {
      this.setState({ bidderLoading: false });
    }
  }

  handleDateTag = (tag, range) => {
    this.setState((prev) => ({
      dateTag: tag,
      search: { ...prev.search, ...range },
    }));
  };

  //  Bidder onChange — store as integer
  handleBidderChange = (selectedOption) => {
    this.setState((prevState) => ({
      search: {
        ...prevState.search,
        bidder: selectedOption ? parseInt(selectedOption.value) : null,
      },
    }));
  };

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      dateTag: 'custom',
      search: { ...prev.search, [name]: value },
    }));
  };
  handleSearch = () => {
    this.fetchWithdrawal();
    this.fetchWithdrawalSymmary();
  };

  handleClear = () => {
    const range = DateRangeTags.resolveRange('7');
    this.setState(
      {
        dateTag: '7',
        search: {
          startDate: range.startDate,
          endDate: range.endDate,
          bidder: null,
        },
      },
      () => {
        this.fetchBidderList();
        this.fetchWithdrawal();
        this.fetchWithdrawalSymmary();
      }
    );
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.fetchWithdrawal();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.fetchWithdrawal();
    });
  };

  handleTypeFilter = (type = null) => {
    this.setState({ type: type }, () => {
      this.fetchWithdrawal();
    });
  };

  getColumns = () => {
    const { type } = this.state;

    const columns = [
      {
        name: 'SL',
        width: '80px',
        sortable: true,
        cell: (row, index) => (this.state.page - 1) * this.state.limit + index + 1,
      },

      {
        name: 'Transaction ID',
        width: '140px',
        sortable: true,
        cell: (row) => <span className="highlight-table-value">{row.transaction_id}</span>,
      },

      {
        name: 'Reference',
        width: '120px',
        cell: (row) => row.reference || '-',
      },

      {
        name: 'Bidder ID',
        width: '100px',
        cell: (row) => <span className="highlight-table-value">{row.user}</span>,
      },

      {
        name: 'Bidder Name',
        width: '160px',
        sortable: true,
        cell: (row) => row.user_relation?.name || '-',
      },

      {
        name: 'Email',
        width: '220px',
        cell: (row) => row.user_relation?.email || '-',
      },
    ];

    if (['auction_payment', 'withdrawal'].includes(type)) {
      columns.push(
        {
          name: 'Client Name',
          width: '120px',
          cell: (row) => (
            <span className="highlight-table-value">
              {row.group?.organization_details?.organization_name || '-'}
            </span>
          ),
        },
        {
          name: 'Group ID',
          width: '100px',
          cell: (row) => <span className="highlight-table-value">{row.group_id || '-'}</span>,
        },

        {
          name: 'Group Name',
          width: '130px',
          cell: (row) => row.group?.group_name || '-',
        },

        {
          name: 'Auction ID',
          width: '100px',
          cell: (row) => (
            <span className="highlight-table-value">{row.auction_relation?.id || '-'}</span>
          ),
        },

        {
          name: 'Auction Name',
          width: '130px',
          cell: (row) => row.auction_relation?.title || '-',
        }
      );
    }

    columns.push(
      {
        name: 'Credit',
        width: '120px',
        right: true,
        sortable: true,
        cell: (row) => (
          <span className="amount-text success">{Number(row.credit || 0).toFixed(3)}</span>
        ),
      },

      {
        name: 'Debit',
        width: '120px',
        right: true,
        sortable: true,
        cell: (row) => (
          <span className="amount-text danger">{Number(row.debit || 0).toFixed(3)}</span>
        ),
      },

      {
        name: 'Method',
        width: '120px',
        cell: (row) => row.method || '-',
      },

      {
        name: 'Receipt',
        width: '130px',
        cell: (row) =>
          row.file_receipt ? (
            <button
              className="button-table"
              onClick={() => window.open(row.file_receipt, '_blank')}
            >
              View File
            </button>
          ) : (
            '-'
          ),
      },

      {
        name: 'Status',
        width: '120px',
        center: true,
        cell: (row) => {
          const statusClass = row.status?.toLowerCase();

          return (
            <span className={`status-badge ${statusClass}`}>{TRANSACTION_STATUS[row.status]}</span>
          );
        },
      },
      {
        name: 'Date',
        width: '180px',
        sortable: true,
        cell: (row) => formatDate(row.created_at),
      }
    );

    return columns;
  };

  render() {
    const { bidders, bidderLoading, search, hideSidebar, withdawalData, withdawalMeta, isLoading } =
      this.state;
    const { startDate, endDate } = search;

    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t('wallet_withdrawal_summary')}
          subtitle={i18n.t('wallet_withdrawal_summary_subtitle')}
        />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">{!hideSidebar && <SideBar />}</div>
              <div
                className={
                  hideSidebar ? 'col-xl-12 col-lg-12 col-md-12' : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => this.setState({ hideSidebar: !hideSidebar })}
                      >
                        {hideSidebar ? (
                          <i className="icon-size-actual" />
                        ) : (
                          <i className="icon-size-fullscreen" />
                        )}
                      </span>
                    </div>
                    <div className="header-action">
                      {/* Back Button */}
                      <NavLink to="/cash-flow" className="button1 button1-gradient button1-back">
                        <ArrowLeft size={18} className="icon" />
                        <span>{i18n.t('back')}</span>
                      </NavLink>
                      <NewDropdown
                        label={i18n.t('export')}
                        // loading={exportLoading}
                        icon={Download}
                        items={[
                          {
                            label: i18n.t('excel'),
                            icon: FileSpreadsheet,
                            onClick: () => this.handleDownload('excel'),
                          },
                        ]}
                      />
                    </div>
                  </div>

                  <div className="card-body">
                    <DateRangeTags activeTag={this.state.dateTag} onChange={this.handleDateTag} />
                    <FilterSection
                      loading={this.state.isLoading}
                      onSearch={this.handleSearch}
                      onClear={this.handleClear}
                    >
                      <div className="select-wrapper floating-label-wrapper">
                        <input
                          id="startDate"
                          type="date"
                          name="startDate"
                          value={startDate}
                          onChange={this.handleSearchChange}
                          className="filter-base floating-input"
                          placeholder=" "
                        />
                        <label htmlFor="startDate" className="floating-label">
                          {i18n.t('start_date')}
                        </label>
                      </div>
                      <div className="select-wrapper floating-label-wrapper">
                        <input
                          id="endDate"
                          type="date"
                          name="endDate"
                          value={endDate}
                          onChange={this.handleSearchChange}
                          className="filter-base floating-input"
                          placeholder=" "
                        />
                        <label htmlFor="endDate" className="floating-label">
                          {i18n.t('end_date')}
                        </label>
                      </div>

                      {/* Bidder Dropdown */}
                      <div className="react-select-wrapper">
                        <Select
                          options={bidders}
                          //  compare number === number
                          value={bidders.find((c) => c.value === this.state.search.bidder) || null}
                          onChange={this.handleBidderChange}
                          name="bidder"
                          styles={selectStyles}
                          menuPlacement="auto"
                          menuPortalTarget={document.body}
                          placeholder={bidderLoading ? `${i18n.t('loading')}...` : i18n.t('all')}
                          isLoading={bidderLoading}
                          isDisabled={bidderLoading}
                          isClearable
                        />
                        <label className="react-select-label">{i18n.t('bidder')}</label>
                      </div>
                    </FilterSection>
                    {isLoading ? (
                      <ClientPaymentSkeleton />
                    ) : (
                      <section className="auction-enrollment">
                        {/* Cards */}
                        <div className="ae-grid">
                          <CashFlowStatCard
                            icon={<ArrowBigDown size={24} strokeWidth={2} />}
                            title="Total Withdrawal"
                            value={withdawalMeta?.withdraw?.sub_total?.amount || 0}
                            subtitle={`${withdawalMeta?.withdraw?.sub_total?.count || 0} Transactions`}
                            iconClass="blue"
                            valueClass="blue-text"
                            color="#1794ae"
                            onClick={() => this.handleTypeFilter('withdrawal')}
                          />
                          <CashFlowStatCard
                            icon={<Wallet size={24} strokeWidth={2} />}
                            title="Total Wallet Withdrawal"
                            value={withdawalMeta?.withdraw?.wallet_withdrawal?.amount || 0}
                            subtitle={`${withdawalMeta?.withdraw?.wallet_withdrawal?.count || 0} Transactions`}
                            iconClass="green"
                            valueClass="green-text"
                            color="#32a852"
                            onClick={() => this.handleTypeFilter('wallet_withdraw')}
                          />

                          <CashFlowStatCard
                            icon={<Gavel size={24} strokeWidth={2} />}
                            title="Total Wallet Auction Payment"
                            value={withdawalMeta?.withdraw?.auction_payment?.amount || 0}
                            subtitle={`${withdawalMeta?.withdraw?.auction_payment?.count || 0} Transactions`}
                            iconClass="yellow"
                            valueClass="yellow-text"
                            color="#bdb61d"
                            onClick={() => this.handleTypeFilter('auction_payment')}
                          />
                        </div>

                        <div className="Data-Listing">
                          {isLoading ? (
                            <TableSkeleton columns={5} rows={2} />
                          ) : withdawalData.length ? (
                            <DataTable
                              keyField={(row) => `${row.id}`}
                              responsive={true}
                              columns={this.getColumns()}
                              data={withdawalData}
                              customStyles={tableStyles}
                              highlightOnHover
                              pointerOnHover
                              pagination
                              paginationServer
                              paginationTotalRows={this.state.total}
                              paginationPerPage={this.state.limit}
                              paginationDefaultPage={this.state.page}
                              paginationRowsPerPageOptions={[15, 25, 50, 100]}
                              paginationComponentOptions={{
                                rowsPerPageText: i18n.t('rows_per_page'),
                                rangeSeparatorText: i18n.t('out'),
                              }}
                              onChangePage={this.onChangePage}
                              onChangeRowsPerPage={this.onChangeRowsPerPage}
                            />
                          ) : (
                            <NoData message={'no_transaction_available'} />
                          )}
                        </div>
                      </section>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default WalletWithdrawalCashFlow;
